import { useEffect, useState } from "react";

export const useFilterState = (initialValue, onBlur) => {
  const [filterValue, setFilter] = useState(initialValue || "");

  useEffect(() => {
    setFilter(initialValue || "");
  }, [initialValue]);

  const handleBlur = () => {
    if (onBlur) {
      onBlur(filterValue);
    }
  };

  return { filterValue, setFilter, handleBlur };
};